var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loader",
    {
      attrs: {
        width: 850,
        height: 160,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("circle", { attrs: { cx: "523", cy: "21", r: "8" } }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "25",
          y: "15",
          rx: "5",
          ry: "5",
          width: "220",
          height: "10",
        },
      }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "523", cy: "52", r: "8" } }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "25",
          y: "45",
          rx: "5",
          ry: "5",
          width: "220",
          height: "10",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "266",
          y: "46",
          rx: "5",
          ry: "5",
          width: "220",
          height: "10",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "606",
          y: "47",
          rx: "5",
          ry: "5",
          width: "220",
          height: "10",
        },
      }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "579", cy: "51", r: "8" } }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "265",
          y: "15",
          rx: "5",
          ry: "5",
          width: "220",
          height: "10",
        },
      }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "578", cy: "21", r: "8" } }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "603",
          y: "14",
          rx: "5",
          ry: "5",
          width: "220",
          height: "10",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "26",
          y: "77",
          rx: "5",
          ry: "5",
          width: "220",
          height: "10",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "267",
          y: "75",
          rx: "5",
          ry: "5",
          width: "220",
          height: "10",
        },
      }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "523", cy: "82", r: "8" } }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "581", cy: "82", r: "8" } }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "606",
          y: "76",
          rx: "5",
          ry: "5",
          width: "220",
          height: "10",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "26",
          y: "104",
          rx: "5",
          ry: "5",
          width: "220",
          height: "10",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "269",
          y: "104",
          rx: "5",
          ry: "5",
          width: "220",
          height: "10",
        },
      }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "523", cy: "110", r: "8" } }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "582", cy: "111", r: "8" } }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "607",
          y: "106",
          rx: "5",
          ry: "5",
          width: "220",
          height: "10",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }